export default "__VITE_ASSET__CNVv6MCR__"